module.exports = __webpack_public_path__ + "img/4.47343650.png";